import { IdName } from '@shared/models/id-name';
import { ApplianceTypeEnums } from './appliance-type.enum';

export const APPLIANCE_TYPES: IdName<number>[] = [
	{ Id: ApplianceTypeEnums.Soft, Name: 'Soft' },
	{ Id: ApplianceTypeEnums.DualLaminate, Name: 'DualLaminate' },
	{ Id: ApplianceTypeEnums.Hard, Name: 'Hard' }
];
